<template>
	<div v-if="!hideFileUploader" class="upload-div">
		<FileUploader
			name="files"
			:limit="uploadConfig.maxFiles"
			:fileMaxSize="uploadConfig.maxSize"
			@options="getFileuploaderOptions"
			@created="createFileUploaderInstance"
			@mounted="createFileUploaderInstance"
			:extensions="uploadConfig.accept"
			:files="JSON.stringify(arrayTemp)"
			:disallowedExtensions="uploadConfig.disallowedExtensions"
		></FileUploader>
	</div>
</template>
<script>
import axios from 'axios';
import $ from 'jquery';
import FileUploader from '@/plugins/Fileuploader.vue';
export default {
	name: 'Fileuploader',
	components: {
		FileUploader
	},
	props: {
		multiple: Boolean,
		meta: Boolean,
		accept: String,
		maxSize: String,
		maxFiles: String,
		hideFileUploader: Boolean,
		theme:String,
		changeInput: String,
		fileUploaded: {
			type: Array,
			default: () => []
		}
	},
	data: function() {
		return {
			fileUploadApi: null,
			fileRecords: [],
			//   uploadUrl: "https://www.mocky.io/v2/5d4fb20b3000005c111099e3",
			//   uploadHeaders: { "X-Test-Header": "vue-file-agent" },
			fileRecordsForUpload: [],
			uploadConfig: {
				disallowedExtensions: [
					'php',
					'php3',
					'php4',
					'php5',
					'sql',
					'js',
					'vue'
				],
				multiple: this.multiple !== null ? this.multiple : true,
				meta: this.meta !== null ? this.meta : true,
				accept: this.accept ? this.accept : 'image/*',
				maxSize: this.maxSize ? this.maxSize : 25,
				maxFiles: this.maxFiles ? this.maxFiles : null
			},
			arrayTemp: []
		};
	},
	watch: {
		fileUploaded: async function(val) {
			this.arrayTemp = [];
			this.imageRender();
		}
	},
	methods: {
		async imageRender() {
			this.arrayTemp = [];
			if (this.fileUploaded.length) {
				for (const item of this.fileUploaded) {
					await this.getDetailImage(item, this.fileUploaded.length);
				}
			}
		},
		createFileUploaderInstance(cmp) {
			this.fileUploadApi = cmp;
		},
		getFileuploaderOptions(cmp) {
			let _this = this;
			var name = cmp.name;
			this.$forceUpdate();
			this.imageRender();
			
			
			cmp.options = {
				changeInput: this.changeInput,
				theme: this.theme,
				addMore: true,
				enableApi: true,
				clipboardPaste: 2000,
				dialogs: {
					// alert dialog
					alert: function(text) {
						return alert(text);
					},

					// confirm dialog
					confirm: function(text, callback) {
						confirm(text) ? callback() : null;
					}
				},
				editor: {
					// editor cropper
					// cropper: {
					// 	// cropper ratio
					// 	// example: null
					// 	// example: '1:1'
					// 	// example: '16:9'
					// 	// you can also write your own
					// 	ratio: null,

					// 	// cropper minWidth in pixels
					// 	// size is adjusted with the image natural width
					// 	minWidth: null,

					// 	// cropper minHeight in pixels
					// 	// size is adjusted with the image natural height
					// 	minHeight: null,

					// 	// show cropper grid
					// 	showGrid: true
					// },
					cropper:true,

					// editor on save quality (0 - 100)
					// only for client-side resizing
					quality: null,

					// editor on save maxWidth in pixels
					// only for client-side resizing
					maxWidth: null,

					// editor on save maxHeight in pixels
					// only for client-size resizing
					maxHeight: null,

					// Callback fired after saving the image in editor
					onSave: async function(
						blobOrDataUrl,
						item,
						listEl,
						parentEl,
						newInputEl,
						inputEl
					) {
						const blob = _this.dataURLtoFile(blobOrDataUrl, item.name);
						item.file = blob;
						if(item.data.uploaded){
							
							item.file.edit=true;
						}else{
							item.file.edit=true;
						}
						_this.filesSelected();
					}
				},
				sorter: {
					// selector exclude on drag (ex: 'input, textarea')
					selectorExclude: null,

					// placeholder html
					// null - will clone the item without content
					placeholder: null,

					// scroll container on drag
					scrollContainer: window,

					// callback fired after sorting, adding and removing a file
					onSort: function(list, listEl, parentEl, newInputEl, inputEl) {
						var api = $.fileuploader.getInstance(inputEl.get(0));
						if(api.getFileList().length){
							api.getFileList().forEach((element,index) => {
								console.log(index)
								console.log()
								if(index==0){
									element.html.find('.type-holder').text('cover')
								}else{
									element.html.find('.type-holder').text('Pic '+ index)
								}
							});
							
						}
						_this.filesSelected();
					}
				},
				afterRender: function(listEl, parentEl, newInputEl, inputEl) {
					
					var plusInput = listEl.find('.fileuploader-thumbnails-input'),
						api = $.fileuploader.getInstance(inputEl.get(0));

					plusInput.on('click', function() {
						api.open();
					});

					api.getOptions().dragDrop.container = plusInput;
				},
				thumbnails: {
					box:
						'<div class="fileuploader-items">' +
						'<ul class="fileuploader-items-list">' +
						'<li class="fileuploader-thumbnails-input"><div class="fileuploader-thumbnails-input-inner"><i class="fileuploader-icon-main"><span>${captions.feedback}</span></i> </div></li>' +
						'</ul>' +
						'</div>',
					item:
						'<li class="fileuploader-item">' +
						'<div class="fileuploader-item-inner">' +
						'<div class="type-holder">${extension}</div>' +
						'<div class="actions-holder">' +
						'<button type="button" class="fileuploader-action fileuploader-action-sort" title="Sort"><i class="fileuploader-icon-sort"></i></button>' +
						'<button type="button" class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fileuploader-icon-remove"></i></button>' +
						'</div>' +
						'<div class="thumbnail-holder">' +
						'${image}' +
						'<span class="fileuploader-action-popup"></span>' +
						'</div>' +
						'<div class="content-holder"><h5>${name}</h5><span>${size2}</span></div>' +
						'<div class="progress-holder">${progressBar}</div>' +
						'</div>' +
						'</li>',
					item2:
						'<li class="fileuploader-item">' +
						'<div class="fileuploader-item-inner">' +
						'<div class="type-holder">${extension}</div>' +
						'<div class="actions-holder">' +
						'<button type="button" class="fileuploader-action fileuploader-action-sort" title="Sort"><i class="fileuploader-icon-sort"></i></button>' +
						'<button type="button" class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fileuploader-icon-remove"></i></button>' +
						'</div>' +
						'<div class="thumbnail-holder">' +
						'${image}' +
						'<span class="fileuploader-action-popup"></span>' +
						'</div>' +
						'<div class="content-holder"><h5 title="${name}">${name}</h5><span>${size2}</span></div>' +
						'<div class="progress-holder">${progressBar}</div>' +
						'</div>' +
						'</li>',
					startImageRenderer: true,
					canvasImage: true,
					synchronImages: true,

					itemPrepend:false,
					_selectors: {
						list: '.fileuploader-items-list',
						item: '.fileuploader-item',
						start: '.fileuploader-action-start',
						sorter: '.fileuploader-action-sort',
						retry: '.fileuploader-action-retry',
						remove: '.fileuploader-action-remove'
					},
					onImageLoaded: function(item, listEl, parentEl, newInputEl, inputEl) {
						
						// if(item.data.crop==false){
						// 	item.editor.cropper=false
						// }
						var plusInput = listEl.find('.fileuploader-thumbnails-input'),
							api = $.fileuploader.getInstance(inputEl.get(0));
						plusInput
							.insertAfter(item.html)
							[
								api.getOptions().limit &&
								api.getChoosedFiles().length >= api.getOptions().limit
									? 'hide'
									: 'show'
							]();
						if(api.getFileList().length){
							api.getFileList().forEach((element,index) => {
								console.log(index)
								console.log()
								if(index==0){
									element.html.find('.type-holder').text('cover')
								}else{
									element.html.find('.type-holder').text('Pic '+ index)
								}
							});
							
						}
						if (item.format == 'image') {
							item.html.find('.fileuploader-item-icon').hide();
						}
						if (!item.html.find('.fileuploader-action-edit').length)
							item.html
								.find('.fileuploader-action-remove')
								.before(
									'<button type="button" class="fileuploader-action fileuploader-action-popup fileuploader-action-edit" title="Edit"><i class="fileuploader-icon-edit"></i></button>'
								);
						if (item.data.uploaded)
							item.html
								.find('.fileuploader-action-remove')
								.addClass('fileuploader-action-success');
						if (item.appended) return;

						// hide current thumbnail (this is only animation)
						if (item.imageIsUploading) {
							item.image.addClass('fileuploader-loading').html('');
						}

						item.imageLoaded = true;
					},
					// onItemShow: function(item, listEl, parentEl, newInputEl, inputEl) {
					// 	// if(item.data.crop==false){
					// 	// 	item.editor.cropper=false
					// 	// }
					// 	var plusInput = listEl.find('.fileuploader-thumbnails-input'),
					// 		api = $.fileuploader.getInstance(inputEl.get(0));
					// 	plusInput
					// 		.insertAfter(item.html)
					// 		[
					// 			api.getOptions().limit &&
					// 			api.getChoosedFiles().length >= api.getOptions().limit
					// 				? 'hide'
					// 				: 'show'
					// 		]();

					// 	if (item.format == 'image') {
					// 		item.html.find('.fileuploader-item-icon').hide();
					// 	}
					// },
					onItemRemove: function(html, listEl, parentEl, newInputEl, inputEl) {
						var plusInput = listEl.find('.fileuploader-thumbnails-input'),
							api = $.fileuploader.getInstance(inputEl.get(0));

						html.children().animate({ opacity: 0 }, 200, function() {
							html.remove();

							if (
								api.getOptions().limit &&
								api.getChoosedFiles().length - 1 < api.getOptions().limit
							)
								plusInput.show();
						});
					},
					// item popup preview {Object}
					popup: {
						// popup append to container {String, jQuery Object}
						container: 'body',

						// enable arrows {Boolean}
						arrows: true,

						// loop the arrows {Boolean}
						loop: true,

						// template: function(e) {
						// 	return `<div class="fileuploader-popup-preview">
						// 	<button type="button" class="fileuploader-popup-move" data-action="prev">
						// 	<i class="fileuploader-icon-arrow-left"></i></button>
						// 	<div class="fileuploader-popup-node node-${format}">${reader.node}</div>
						// 	<div class="fileuploader-popup-content"><div class="fileuploader-popup-footer"
						// 	><ul class="fileuploader-popup-tools">' + ("image" == e.format && e.reader.node && e.editor ? (e.editor.cropper ? '<li><button type="button" data-action="crop"><i class="fileuploader-icon-crop"></i> ${captions.crop}</button></li>' : "") + (e.editor.rotate ? '<li><button type="button" data-action="rotate-cw"><i class="fileuploader-icon-rotate"></i> ${captions.rotate}</button></li>' : "") : "") + ("image" == e.format ? '<li class="fileuploader-popup-zoomer"><button type="button" data-action="zoom-out">&minus;</button><input type="range" min="0" max="100"><button type="button" data-action="zoom-in">&plus;</button><span></span> </li>' : "") + (e.data.url ? '<li><a href="' + e.data.url + '" data-action="open" target="_blank"><i class="fileuploader-icon-external"></i> ${captions.open}</a></li>' : "") + '<li><button type="button" data-action="remove"><i class="fileuploader-icon-trash"></i> ${captions.remove}</button></li></ul></div><div class="fileuploader-popup-header"><ul class="fileuploader-popup-meta"><li><span>${captions.name}:</span><h5>${name}</h5></li><li><span>${captions.type}:</span><h5>${extension.toUpperCase()}</h5></li><li><span>${captions.size}:</span><h5>${size2}</h5></li>' + (e.reader && e.reader.width ? "<li><span>${captions.dimensions}:</span><h5>${reader.width}x${reader.height}px</h5></li>" : "") + (e.reader && e.reader.duration ? "<li><span>${captions.duration}:</span><h5>${reader.duration2}</h5></li>" : "") + '</ul><div class="fileuploader-popup-info"></div><ul class="fileuploader-popup-buttons"><li><button type="button" class="fileuploader-popup-button" data-action="cancel">${captions.cancel}</a></li>' + (e.editor ? '<li><button type="button" class="fileuploader-popup-button button-success" data-action="save">${captions.confirm}</button></li>' : "") + 
						// 	'</ul></div></div><button type="button" class="fileuploader-popup-move" data-action="next"><i class="fileuploader-icon-arrow-right"></i></button></div>`
						// },

						// Callback fired after creating the popup
						// we will trigger by default buttons with custom actions
						onShow: function(item) {
								
								item.popup.html
									.on('click', '[data-action="remove"]', function(e) {
										item.popup.close();
										item.remove();
									})
									.on('click', '[data-action="cancel"]', function(e) {
										item.popup.close();
									})
									.on('click', '[data-action="save"]', function(e) {
										if (item.editor) item.editor.save();
										if (item.popup.close) item.popup.close();
									});
						},

						// Callback fired after closing the popup
						onHide: null
					}
				},
				// Callback fired after deleting a file
				// by returning false, you can prevent a file from removing
				onRemove: function(item, listEl, parentEl, newInputEl, inputEl) {
					_this.filesSelected();
					return true;
				},
				onSelect: function(item, listEl, parentEl, newInputEl, inputEl) {
					_this.filesSelected();
				},
				onSupportError: function(parentEl, inputEl) {
					// callback will go here
					// 
				},
				captions: $.extend(true, {}, $.fn.fileuploader.languages['th'], {
					feedback: this.$t('select image file'),
					feedback2: this.$t('Drag and drop files here'),
					drop: this.$t('Drag and drop files here'),
					or: this.$t('or'),
					button: this.$t('select image file')
				})
			};
		},
		filesSelected() {
			this.$emit('childToParent', this.fileUploadApi.api.getFiles());
		},
		makeToastError(message) {
			this.$bvToast.toast(message, {
				title: `Error!`,
				variant: 'danger',
				solid: true
			});
		},
		dataURLtoFile(dataurl, filename) {
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename, { type: mime });
		},
		async getDetailImage(urlImage, length) {
			await axios
				.get(urlImage, {
					responseType: 'arraybuffer'
				})
				.then(result => {
					let parts = urlImage.split('/');
					let name = parts[parts.length - 1];
					let replaceSize = name.replace('832x468', '250x141');
					let splitDot = name.split('.');
					let _ext = splitDot[splitDot.length - 1];
					const buffer = Buffer.from(result.data, 'base64');
					let file = new File([buffer], name, buffer);
					
					let objImageDetail = {
						name: name,
						size: file.size,
						type: 'image/jpg',
						file: file,
						local: file,
						uploaded: true,
						crop:false,
						editor:null,
						data: {
							crop:false,
							thumbnail: file, // item custom thumbnail; if false will disable the thumbnail (optional)
							readerCrossOrigin: 'anonymous', // fix image cross-origin issue (optional)
							readerForce: true, // prevent the browser cache of the image (optional)
							readerSkip: false, // skip file from reading by rendering a thumbnail (optional)
							popup: true, // remove the popup for this file (optional)
							uploaded: true
						}
					};
					this.arrayTemp.push(objImageDetail);
					this.fileUploadApi.api.append(objImageDetail);
				});
		},
	}
};
</script>
<style lang="scss">
@import 'style.scss';
</style>
